<!--
 * @Author: your name
 * @Date: 2020-08-25 10:40:08
 * @LastEditTime: 2020-08-31 10:22:00
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \demo\src\components\HelloWorld.vue

-->
<template>
<div class="hello" id="hello">
    <svg version="1.1" id="svgh" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1920 840" style="enable-background:new 0 0 1920 840;" xml:space="preserve">
        <path class="st0" d="M1263.05,90.02 c -4.74, 2.25 -9.36,4.76 -14.72 , 5.42 c -2.47,0.3-4.9,0.39-7.25-0.24

c-5.02-1.36-9.66-0.26-13.51,2.79 c -3.46,2.75 -7.37,4.71 -10.86,7.37 c-6.12,4.67-10.16,10.6-11.46,18.2

c-1.39,8.14-0.59,16.03,3.59,23.33c1.33,2.32,3.63,3.77,5.33,5.76c3.15,3.68,6.41,7.31,8.64,11.68 c 3.27,6.4,1.3,10.01-5.9,10.81

c-2.69,0.3-5.39,0.45-8.08,0.76 c -2.12,0.24 -2.8,1.31 -1.66,3.29 c1.47,2.58,3.68,4.41,6.01,6.17c3.42,2.57,6.92,5.01,8.7,9.26

c2.19,5.22,2.69,10.36,0.12,15.48c-2.3,4.6-2.8,9.44-2.78,14.47c 0.03,8.88 -1.31,17.43 -7.5,24.38 c-4.03,4.52-9.21,7.55-14.45,10.49

c-4.38,2.46-9.43,3.77-13.01,7.64c-0.58,0.62-1.12,1.24-1.58,1.93c-2.52,3.84-5,4.56-9.31,2.8c-3.92-1.6-7.26-4.16-10.81-6.38

c-0.96-0.6-1.9-1.07-3.01-1.38c-4.32-1.21-8.3-3.16-12.15-5.46c-7.47-4.45-15.48-4.47-23.66-2.51

c-8.82,2.12-16.87,6.05-24.52,10.81c-2.23,1.39-3.93,3.47-5.29,5.7 c -2.84,4.65 -6.32,8.7 -10.06,12.68

c-4.56,4.84-4.85,11.1-3.71,17.44 c 1.17,6.52,4.21,12.18, 8.11,17.4 c 2.52,3.37,4.31,7.04,5.06,11.16c0.96,5.26-2.06,8.3-7.33,7.58

c-3.16-0.43-5.76-2.17-8.54-3.48c-1.86-0.87-3.66-1.83-5.8-1.92c-1.58-0.07-1.99,0.61-1.85,2.01c0.24,2.43,1.33,4.57,2.79,6.36

c2.43,2.97,4.49,6.23,7.27,8.92c2.84,2.74,4.93,6.07,6.89,9.47c0.66,1.15,1,2.43,1.1,3.76c0.7,9-0.76,17.31-6.07,25.04

c-5.04,7.32-10.15,14.59-16.28,20.96c-4.34,4.51-10.24,7.24-16.09,9.62c-6.11,2.48-12.65,3.95-18.17,7.79

c-6.13,4.27-12.61,4.8-19.44,1.88c-2.69-1.15-5.28-0.97-7.72,0.76c-1.45,1.03-2.96,1.92-4.67,2.55c-2.77,1.03-4.87,0.44-7.18-1.48

c-4.76-3.95-10.37-6.59-16.04-9.01c-7.78-3.32-15.72-6.19-24.32-6.42c-5.94-0.16-11.26,1.36-16.25,4.93

c -6.02,4.31 -8.79,11.06 -13.53,16.3 c-3.77,4.16-7.53,8.33-11.82,11.92c-5.32,4.45-11.75,5.82-18.56,5.86

c-9.7,0.06-18.57,2.92-26.55,8.4c-4.85,3.34-10.21,2.13-15.62-1.64c-7.15-4.98-13.75-10.77-22.19-13.65

c -3.12-1.07-6.28-1.95 -9.58-1.95 c-5.68,0-8.53,3.96-6.79,9.37c1.96,6.07,5.1,11.68,6.91,17.81c1.03,3.49,1.57,6.71-0.83,10.15

c-1.7,2.43-3.82,3.44-6.3,3.38c-8.66-0.21-17.01,1.16-25.21,3.89c-4.79,1.6-8.73-0.71-12.45-3.43c-4.72-3.47-8.99-7.58-14.22-10.31

c-7.75-4.06-16.18-5.74-24.78-6.68c-3.35-0.36-6.74-0.33-10.11-0.56c-7-0.47-12.69,2.16-17.66,6.96c-4.03,3.9-8.12,7.79-13.2,10.38

c-4.74,2.41-9.82,3.53-14.99,2.12c-4.88-1.33-9.46-0.87-13.38,1.94c-3.84,2.76-8.38,3.59-12.44,5.67

c-6.73,3.44-10.74,8.78-12.67,15.87c-0.96,3.54-1.05,7.18-0.76,10.85c0.47,5.96,2.67,10.91,7.3,14.95c3.87,3.37,7.04,7.5,9.4,12.12

c2.83,5.54,1.03,9.11-5.11,10.07c-3.22,0.5-6.51,0.62-9.76,0.97c-2.21,0.24-2.67,1.33-1.56,3.29c1.43,2.52,3.54,4.33,5.85,5.92

c4.58,3.15,8.29,6.87,9.74,12.52c0.85,3.31,1.22,6.73-0.25,9.66c-3.38,6.74-3.53,13.83-3.59,21.08

c-0.06,7.34-1.35,14.45-5.69,20.69c-4.9,7.04-11.34,12.05-19.36,14.98c-4.57,1.67-8.95,3.4-12.57,6.99

c-2.58,2.56-6.06,1.6-9.17,0.25c-4.6-1.99-8.56-5.05-12.74-7.74c-1.07-0.69-2.17-0.98-3.28-1.39c-4.18-1.56-8.26-3.29-12.19-5.48

c-8.39-4.68-17.23-4.29-26.09-1.4c-9.16,2.98-17.15,7.96-24.13,14.56c-2.2,2.08-3.78,4.65-5.16,7.32c-1.82,3.5-3.68,7.01-6.63,9.67

c-5.33,4.79-5.7,10.58-3.94,16.97c1.74,6.29,5.64,11.35,9.22,16.6c1.55,2.27,2.58,4.78,3.09,7.49c1.18,6.25-1.99,9.36-8.25,8.1

c-2.98-0.6-5.61-2.1-8.32-3.38c-1.86-0.88-3.71-1.76-5.86-1.83c-1.69-0.05-2.19,0.76-1.99,2.25c0.28,2.1,1.14,4.06,2.51,5.57

c2.26,2.49,4.12,5.34,6.72,7.54c3.52,2.98,6.58,6.47,9.01,10.31c4.77,7.56,5.03,19.82-5.02,26.64c-4.66,3.16-9.69,5.73-14.15,9.12

c-2.79,2.11-5.39,4.6-7.62,7.29c-3.69,4.45-8.56,7.32-13.29,10.25c-3.85,2.39-7.84,4.64-11.83,6.82

c-7.51,4.1-15.58,4.13-23.78,3.18c-1.67-0.2-3.39-0.57-5.03-0.39c-5.85,0.65-11.7,1.44-17.52,2.35c-1.43,0.22-2.9,0.91-4.12,1.73

c-8.03,5.4-15.73,4.22-23.23-1.05c-3.72-2.62-7.41-5.29-11.02-8.06c-6.18-4.74-13.39-6.11-20.89-6.27

c-5.69-0.12-11.36,0.56-17.09-0.34c-4.91-0.77-8.22,3.58-7.15,8.84c0.96,4.76,3.64,8.78,5.87,12.99c1.76,3.31,3.65,6.57,4.61,10.21

c1.12,4.26,0.42,6.02-3.12,8.58c-2.57,1.86-5.52,2.71-8.6,3.12c-0.97,0.13-1.99,0.09-2.83-0.81c-2.28-2.47-4.66-4.86-7.12-7.41

c2.26,0.37,4.45,0.93,6.67,1.04c6.49,0.32,9.53-3.78,7.33-9.93c-1.39-3.88-3.07-7.65-4.62-11.47c-1.09-2.7-1.98-5.45-2.74-8.27

c-1.39-5.14,2.41-11.5,8.77-11.13c7.78,0.45,15.29-1.17,22.49-4.07c4.84-1.95,8.7,0.03,12.46,2.76c3.16,2.3,5.99,5,9.17,7.29

c10.21,7.34,21.8,8.57,33.91,8.57c8.69,0,14.99-4.52,21.41-9.33c8.47-6.35,17.73-10.06,28.6-8.06c4.95,0.91,9.36-1,13.15-3.75

c3.67-2.66,7.84-4.27,11.6-6.73c9.78-6.4,16.72-14.64,14.08-28.75c-0.92-4.91-2.87-8.96-6.64-12.32c-3.37-2.99-6.03-6.66-7.88-10.8

c-2.19-4.91-0.68-7.9,4.51-9.27c3.47-0.91,7.07-0.62,10.57-1.24c3.25-0.57,3.69-1.88,1.52-4.47c-2.31-2.76-5.29-4.78-8.2-6.78

c-4.99-3.42-8.47-12.03-5.35-17.09c3.72-6.02,3.65-12.45,4.33-18.9c0.72-6.84,3.74-12.66,7.82-17.99

c4.95-6.46,11.41-10.66,19.34-12.6c3.61-0.89,6.7-2.74,9.47-5.26c2.57-2.34,5.83-2.94,9.2-2.59c2.97,0.3,5.85,1.02,8.68,2.03

c2.96,1.05,5.94,2.08,9.14,2.41c3.82,0.39,7.42,1.74,10.84,3.47c9.66,4.87,19.69,4.65,29.8,2c7.25-1.9,14.09-4.93,20.26-9.25

c2.3-1.61,3.94-3.97,5.14-6.54c2.26-4.83,5.06-9.27,8.23-13.6c4.05-5.53,3.85-12.12,2.46-18.59c-1.42-6.6-4.45-12.47-8.48-17.86

c-2.61-3.5-4.54-7.35-5.16-11.73c-0.84-5.99,2.62-8.95,8.42-7.2c1.6,0.49,3.13,1.24,4.66,1.94c1.62,0.74,3.17,1.64,4.81,2.32

c1.87,0.77,4.29,2.27,5.71,0.56c1.33-1.6-0.25-3.91-1.29-5.67c-1.77-2.99-4.25-5.44-6.6-7.94c-3.27-3.48-6.8-6.7-9.69-10.54

c-4.36-5.78-4.36-12.19-2.69-18.76c1.58-6.25,5.35-11.3,10.54-14.78c8.34-5.6,15.58-12.46,23.22-18.87

c5.17-4.34,10.86-7.43,17.33-9.23c3.52-0.98,7-2.13,10.46-3.3c4.41-1.49,8.84-2.4,13.52-1.4c1.85,0.39,3.75,0.11,5.59-0.22

c3.43-0.61,6.87-0.8,10.35-0.89c4.03-0.1,7.88-0.91,11.69-2.57c8.45-3.69,16.5-1.98,23.94,3.01c4.55,3.05,8.87,6.46,13.45,9.47

c7.41,4.86,15.79,6.07,24.43,5.89c4.17-0.08,8.32-0.29,12.45,0.57c7.25,1.51,9.99-4.74,8.45-9.72c-1.53-4.97-4.34-9.32-6.7-13.88

c-1.6-3.08-3.26-6.15-3.87-9.61c-0.46-2.61,0.03-4.89,2.48-6.61c8.06-5.63,16.05-4.52,24.14-0.14c7.12,3.86,14.55,6.62,22.71,7.51

c9.08,0.99,16.74-1.99,23.65-7.45c8.08-6.38,17.41-10.4,26.69-14.55c6.58-2.94,12.9-6.48,19.72-8.87

c5.11-1.79,9.75-4.69,15.21-5.72c12.05-2.28,23.88-1.31,35.64,1.72c2.36,0.61,4.85,1.04,6.97,2.14c6.55,3.38,13.56,2.92,20.54,2.88

c1.92-0.01,3.54-0.74,5.2-1.79c11.23-7.11,22.92-12.34,36.73-8.42c5.69,1.62,10.82-0.26,15.35-3.5c2.95-2.11,6.32-3.51,8.99-6.13

c3.38-3.32,5.64-7.15,6.64-11.67c1.72-7.78,3.08-15.62,2.59-23.66c-0.22-3.67-1.25-6.9-3.85-9.67c-3.8-4.04-6.83-8.65-9.18-13.67

c-2.72-5.81-1-9.16,5.3-10.29c2.94-0.52,5.94-0.72,8.91-1.05c2.39-0.27,2.89-1.46,1.68-3.45c-1.43-2.35-3.51-4.03-5.66-5.72

c-3.26-2.57-6.79-4.81-8.64-8.94c-2.34-5.23-2.92-10.34-0.16-15.4c2.61-4.79,3.14-9.83,3.27-15.16c0.19-8.35,1.04-16.62,6.4-23.64

c5.26-6.89,11.88-11.84,20.22-14.28c4.69-1.37,9.26-2.68,12.92-6.32c1.91-1.91,4.71-1.53,7.23-0.79c3.64,1.07,6.78,3.16,9.87,5.23

c3.1,2.07,6.16,4.07,9.81,5.14c3.39,1,6.52,2.61,9.59,4.46c9.68,5.84,19.39,4.44,28.83-0.67c5.68-3.07,11.22-6.41,16.71-9.82

c2.3-1.43,4.06-3.57,5.51-5.92c2.21-3.57,4.14-7.35,7.15-10.36c6.37-6.39,6.18-14.05,4.17-21.97c-1.54-6.06-4.59-11.41-8.32-16.42

c-2.6-3.5-4.42-7.39-5.14-11.75c-0.95-5.79,2.38-8.8,8.08-7.27c2.92,0.79,5.47,2.41,8.15,3.73c1.77,0.87,3.54,1.7,5.57,1.81

c1.5,0.08,2.04-0.44,1.78-1.98c-0.46-2.69-1.75-5.02-3.47-6.97c-3.34-3.78-6.76-7.5-10.34-11.08c-4.72-4.73-8.78-9.93-9.46-17.05

c-0.72-7.57,1.09-14.12,6.09-20.05c4.55-5.39,10.46-9.41,14.64-15.07c4.5-6.09,10.41-10.71,15.78-15.9

c0.67-0.51,1.63-0.49,2.18-1.21c6.69-5.03,13.67-9.5,22.12-10.96c4.42-0.76,8.72-0.49,12.9,1.46c4.74,2.21,9.97,2.42,15.04,3.24

c2.03,0.33,4.07,0.64,6.07,1.14c4.91,1.21,9.67,0.26,14.42-0.87c8.44-2,15.84,0.54,22.8,5.16c4.89,3.24,9.2,7.24,14.21,10.35

c6.46,4.01,13.51,5.34,20.93,5.14c4.85-0.13,9.65-0.61,14.53-0.02c5.57,0.67,8.93-3.47,7.79-8.99c-0.96-4.69-3.48-8.69-5.7-12.81

c-1.56-2.9-3.09-5.8-4.29-8.86c-2.23-5.69-1-8.99,4.38-11.73c7.24-3.68,14.13-2.28,20.91,1.4c7.13,3.87,14.61,6.51,22.77,7.47

c8.88,1.05,16.52-1.54,23.27-6.91c11.46-9.13,24.79-14.08,38.73-17.45c8.54-2.07,16.45-5.37,24.25-9.24

c9.85-4.89,20.39-7.35,31.3-8.5c4.28-0.45,8.51-1.35,12.75-2.11c1.29-0.23,2.83-0.52,3.55-1.55c3.57-5.09,9.09-8.04,13.32-12.31

c5.55-5.6,11.82-6.93,19.2-6.13c2.81,0.3,4.93,1.2,6.65,3.42c1.32,1.7,2.89,3.2,4.35,4.79c0.85,0.97,0.17,1.73-0.6,1.91

c-2.18,0.5-4.19,1.68-6.48,1.7c-1.52,0.01-2.97-0.32-4.25-1.23c-1.15-0.81-2.37-1.5-3.63-2.13c-1.81-0.9-3.54-1.26-5.13,0.43

c-1.74,1.85-0.29,3.24,0.66,4.7c4.69,1.84,9.48,2.6,14.45,1.4c0.86-0.21,1.97-0.89,2.38,0.4c0.33,1.05-0.81,1.36-1.56,1.62

c-5.12,1.76-10.02,3.18-15.18-0.62c-3.85-2.84-6.05-1.77-8.09,2.59c-1.7,4.15-3.11,8.44-5.86,12.09c-1.98,2.63-3.28,2.85-6.15,1.37

c-2.69-1.38-5.71-1.65-8.64-2.08c-9.15-1.33-18.32-2.87-27.6-1.37c-7.03,1.14-12.95,4.46-18.25,9.23

c-6.14,5.53-10.8,12.4-16.9,17.95c-1.33,0.9-2.55,1.94-3.56,3.2c-4.77,5.1-9.85,9.81-17.03,11.12c-3.1,0.56-6.3,0.68-9.46,0.72

c-6.65,0.08-12.95,1.59-19.08,4.02c-0.61,0.64-1.56,0.64-2.21,1.2c-8.58,6.42-15.67,1.79-21.93-3.15

c-7.17-5.66-14.64-10.68-23.84-12.41c-1.28-0.24-2.61-0.4-3.91-0.39c-5.76,0.04-8.71,4.12-6.75,9.64

c2.11,5.91,4.63,11.67,6.78,17.57c1.27,3.48,1.81,6.92-0.53,10.48c-1.53,2.33-3.41,3.61-5.89,3.67c-8.41,0.18-16.44,1.9-24.26,4.98

c-4.75,1.87-8.66-0.51-12.31-3.3c-5.24-4.01-10.05-8.62-16.06-11.56c-8.66-4.24-17.95-6.43-27.34-8.23

c-5.58-1.07-11.12-2.51-16.87-2.46c-5.79,0.05-10.52,3.04-15.4,5.6c-1.07,0.56-2.07,1.25-3.1,1.88

C1264.29,89.41,1263.59,89.58,1263.05,90.02z" />
        <path class="st1" d="M1578.26,13.95c-0.82-1.51-2.86-2.72-1.04-4.84c1.93-2.25,3.73-2.67,6.41-1.28c0.91,0.47,1.82,1,2.59,1.66

c3.88,3.36,7.79,1.29,11.7,0.14c0.52-0.15,0.43-0.77,0.47-1.22c1.06,1.08,2.84,1.55,2.95,3.44c0.11,1.83-1.48,2.93-2.42,3.83

c-2.27,2.2-4.77,4.43-8.17,4.9c-0.2,0.03-0.44-0.27-0.66-0.41c0.28-0.46,0.03-1.04,0.36-1.48c2.41-1.29,5.18-1.92,7.1-4.09

c0.61-0.69,1.36-1.25,1.76-2.69C1592.54,18,1585.4,15.97,1578.26,13.95z" />
        <path class="st2" d="M1578.26,13.95c3.02,0.41,6.09,0.61,9.04,1.3c4.54,1.06,7.93-0.88,11.16-3.6c0.52-0.44,0.94-1.46,1.8-0.73

c0.92,0.79,0.15,1.46-0.38,2.13c-2.4,3.08-5.67,4.79-9.26,6.03c-2.82,1.06-5.63,0.94-8.44-0.01l0.01,0.01

c-0.63-0.6-1.67-0.46-2.21-1.22c-4.57-2.98-5.28-3.17-9.03,1.33c0.56-3.77,3.12-5.34,6.47-3.89c1.28,0.55,2.51,1.21,3.73,1.88

c5.11,2.78,9.63,0.22,14.28-1.45c-5.31,1.88-10.47,0.4-15.67-0.55C1578.99,15.02,1578.25,15.01,1578.26,13.95z" />
        <path class="st3" d="M1582.18,19.07c2.81,0.15,5.63,0.33,8.44,0.01c0.04,0.48-0.08,0.88-0.55,1.11c-1.65,0.02-3.3,0.05-4.95,0.05

C1584,20.23,1582.91,20.08,1582.18,19.07z" />
        <path class="st4" d="M1484.01,59.58c0.58-1.74,1.94-2.61,3.55-3.2C1486.72,57.82,1485.3,58.63,1484.01,59.58z" />
        <path class="st3" d="M1579.98,17.85c0.9,0.1,1.78,0.26,2.21,1.22C1581.18,19.15,1580.29,19.03,1579.98,17.85z" />
        <path class="st5" d="M1263.05,90.02c0.19-1.01,1-1,1.77-1.07C1264.55,89.83,1263.9,90.09,1263.05,90.02z" />
        <path class="st6" d="M1232.11,83.31c-0.35,1.08-1.29,1.11-2.18,1.21C1230.36,83.59,1231.25,83.47,1232.11,83.31z" />
        <path class="st7" d="M1436.23,76.64c0.45-0.93,1.32-1.08,2.21-1.2C1438.03,76.45,1437.12,76.54,1436.23,76.64z" />
        <path class="st8" d="M1431.21,69.74c-0.38,0-0.92,0.18-1.14-0.39c-0.21-0.56,0.23-0.94,0.64-1.09c9.45-3.4,16.26-11.13,25.18-15.37

c6.07-2.89,12.11-5.87,18.67-7.57c0.86-0.22,1.98-0.88,2.52,0.14c0.45,0.85-0.66,1.45-1.22,2c-12.37,12.2-27.12,19.66-44.31,22.23

C1431.45,69.7,1431.36,69.71,1431.21,69.74z" />
        <path class="st9" d="M861.27,454.53c2-2.16,4.73-2.27,6.78-3.7c6.38-4.44,12.45-9.39,19.48-12.85c6.12-3.01,12.19-6.14,18.6-8.53

c0.76-0.28,1.69-1.08,2.32-0.28c0.76,0.98-0.42,1.66-0.95,2.34c-4.34,5.49-9.99,9.46-15.99,12.77

c-8.69,4.81-17.88,8.53-27.72,10.39c-0.55,0.1-1.11,0.17-1.66,0.2C861.96,454.88,861.78,454.74,861.27,454.53z" />
        <path class="st10" d="M1101.93,246.18c-3.75,2.37-6.07,5.96-8.35,9.61c-1.1,1.76-2.57,3.4-4.35,4.32c-4.05,2.08-7.56,4.68-10.1,8.5

c-0.35,0.53-0.65,1.27-1.49,0.8c-0.68-0.38-1.26-0.99-0.98-1.82c0.36-1.05,0.44-2.16,1.07-3.16c4.01-6.4,9.06-11.79,15.17-16.23

c2.04-1.49,4.49-1.77,6.76-2.56c0.65-0.32,1.39-0.71,2.04-0.7C1102.97,244.96,1102.76,245.59,1101.93,246.18z" />
        <path class="st11" d="M1185.82,260.2c3.9-3.82,6.27-8.91,10.5-12.48c1.67-1.4,3.54-2.45,5.43-3.36c2.91-1.41,4.78-3.82,6.87-6.06

c0.46-0.5,0.67-1.54,1.68-0.86c0.83,0.56,0.74,1.3,0.49,2.22c-0.64,2.36-2.14,4.26-3.73,5.85c-5.51,5.51-10.99,11.14-18.33,14.35

c-0.58,0.25-1.06,0.73-1.58,1.1C1186.4,261.25,1185.8,261.28,1185.82,260.2z" />
        <path class="st11" d="M618.33,648.1c4.18-2.68,7.13-6.46,9.84-10.55c1.48-2.24,3.65-4.01,5.98-5.41c3.15-1.89,5.21-4.73,7.19-7.68

c0.33-0.49,0.43-1.44,1.36-0.89c0.56,0.33,1.13,0.91,0.85,1.62c-0.44,1.12-0.51,2.31-1.14,3.43c-3.73,6.73-8.83,12.28-15.01,16.72

c-2.27,1.63-5.28,2.25-7.95,3.32C618.77,649.09,618.32,649.05,618.33,648.1z" />
        <path class="st11" d="M528.73,638c-2.84,1.94-4.87,4.67-6.59,7.52c-2.28,3.78-5.45,6.5-8.94,9.01c-2.22,1.6-3.69,3.93-5.31,6.1

c-0.38,0.51-0.65,1.27-1.49,0.71c-0.6-0.4-0.85-0.97-0.58-1.7c0.29-0.79,0.42-1.66,0.85-2.36c3.92-6.5,8.44-12.5,14.58-17.12

c1.89-1.42,4.14-2.01,6.32-2.75C528.26,637.02,528.75,637.02,528.73,638z" />
        <path class="st1" d="M896.78,450.28c5.93-5.34,11.84-10.69,17.78-16.01c2.05-1.83,4.01-3.82,7.1-5.2c-0.47,1.3-0.57,2.3-1.1,2.93

c-6.04,7.07-11.83,14.45-20.83,18.12c-0.94,0.39-1.97,0.57-2.96,0.85c-0.14-0.15-0.18-0.3-0.14-0.45

C896.69,450.35,896.73,450.28,896.78,450.28z" />
        <path class="st12" d="M1473.87,62.97c-1.29,0.78-2.57,1.56-3.86,2.34c-0.96-0.21-2.01,2.06-2.91-0.1

c8.67-9.67,18.49-17.54,23.39-18.45c-3.83,6.12-9.99,9.48-14.29,14.6C1475.38,61.82,1474.78,62.63,1473.87,62.97z" />
        <path class="st13" d="M693.89,472.3c-5.1,2.82-10.78,4-16.29,5.66c-0.71,0.28-1.31,0.36-1.28-0.7c5.25-2.99,11.14-4.09,16.87-5.65

C693.83,471.43,694.01,471.72,693.89,472.3z" />
        <path class="st14" d="M618.33,648.1c0.24,0.46,0.67,0.54,1.12,0.57c-5.59,3.64-11.35,6.12-17.99,2.34

C607.4,651.76,613.08,651.09,618.33,648.1z" />
        <path class="st15" d="M1256.38,77.7c-4.4,1.2-8.62,2.91-12.86,4.57c-0.71,0.28-1.31,0.37-1.28-0.7c2.78-2.41,6.12-3.62,9.63-4.43

c1.22-0.74,2.72,0.26,3.92-0.63l-0.01,0.01c0.37-0.04-0.12-0.08,0.25-0.11c0.69-0.05,1.75-0.48,1.94,0.32

C1258.22,77.85,1256.76,77.07,1256.38,77.7z" />
        <path class="st16" d="M1021.89,424.89c4.08-2.25,8.26-4.22,12.87-5.14c0.64-0.02,1.52-0.78,1.74,0.55

c-4.13,1.68-7.92,4.18-12.34,5.16C1023.29,425.71,1022.3,426.45,1021.89,424.89z" />
        <path class="st17" d="M463.93,797.52c-3.1,2.55-6.76,3.59-10.67,3.98c-1.36,0.06-2.84,0.91-3.98-0.59

c4.6-0.95,9.06-2.39,13.46-4.01C463.44,796.53,463.94,796.54,463.93,797.52z" />
        <path class="st14" d="M1106.35,242.71c4.22-2.35,8.47-2.05,12.75,0c-3.63,0.28-7.31-0.11-10.9,0.74

C1107.41,243.64,1106.45,244.26,1106.35,242.71z" />
        <path class="st18" d="M1180.94,265.54c-3.04,2.78-6.4,1.94-9.82,0.64c2.66-0.46,5.33-0.91,7.99-1.37

C1179.9,264.59,1180.84,264,1180.94,265.54z" />
        <path class="st19" d="M536.04,632.89c2.74-1.78,5.89-1.86,8.98-2.22c0.35,0.28,0.95,0.42,0.58,1.08c-2.81,0.34-5.55,0.96-8.26,1.77

C536.72,633.7,536.02,634.02,536.04,632.89z" />
        <path class="st20" d="M1106.35,242.71c0.4,0.79,1.18,0.64,1.85,0.74c-2.09,0.91-4.19,1.82-6.28,2.73c0.06-0.41,0.62-1.09-0.49-0.83

c-0.58,0.14-1.18,0.2-1.78,0.3C1101.7,244.23,1103.98,243.36,1106.35,242.71z" />
        <path class="st21" d="M463.93,797.52c-0.22-0.54-0.71-0.56-1.18-0.62c2.3-1.74,5.06-2.41,7.74-3.35

C468.47,795.18,466.4,796.68,463.93,797.52z" />
        <path class="st22" d="M449.29,800.91c1.19,1.11,2.69,0.14,3.98,0.59c-2.67,0.76-5.4,0.87-8.87,1.2

C446.22,801.05,447.71,800.86,449.29,800.91z" />
        <path class="st23" d="M1180.94,265.54c-0.4-0.78-1.14-0.68-1.83-0.73c1.67-1,3.34-2,5-2.99c0.44,0.1,0.69,0.37,0.78,0.81

C1183.69,263.75,1182.49,264.89,1180.94,265.54z" />
        <path class="st24" d="M676.32,477.25c0.27,0.52,0.76,0.63,1.28,0.7c-1.94,0.9-3.9,1.74-6.58,2.14

C672.68,478.12,674.57,477.82,676.32,477.25z" />
        <path class="st23" d="M1242.24,81.57c0.26,0.55,0.78,0.61,1.28,0.7c-1.72,0.92-3.45,1.84-5.17,2.76c-0.94,0.05-0.97-0.36-0.51-1.01

C1239.3,83.2,1240.77,82.39,1242.24,81.57z" />
        <path class="st25" d="M1467.1,65.2c0.93,1.21,1.95-0.36,2.91,0.1c-1.71,1.56-3.88,1.89-6.54,2.61

C1464.67,66.32,1465.9,65.77,1467.1,65.2z" />
        <path class="st26" d="M536.04,632.89c0.28,0.52,0.79,0.58,1.3,0.64c-1.93,0.92-3.86,1.85-5.8,2.77c-0.37-0.07-0.59-0.28-0.67-0.65

C532.5,634.55,534.17,633.53,536.04,632.89z" />
        <path class="st27" d="M1039.19,418.61c1.97-0.59,3.94-1.18,5.91-1.77c-1.23,1.64-2.97,1.89-4.63,2.32

C1040.09,418.86,1039.44,419.19,1039.19,418.61z" />
        <path class="st28" d="M1256.38,77.7c0.39-0.3,0.78-0.6,1.25-0.97c-0.69-0.08-1.27-0.15-1.86-0.21c1.42-0.85,3.01-0.41,4.51-0.6

c0.95,0.01,1.04,0.44,0.55,1.15C1259.35,77.27,1257.87,77.49,1256.38,77.7z" />
        <path class="st24" d="M1039.19,418.61c0.43,0.18,0.85,0.37,1.28,0.55c-1.32,0.38-2.65,0.77-3.97,1.15

c-0.44-0.62-1.15-0.38-1.74-0.55C1036.18,419.17,1037.59,418.54,1039.19,418.61z" />
        <path class="st29" d="M1021.89,424.89c0.58,0.89,1.48,0.47,2.26,0.58c-1.1,1.03-2.54,1.04-3.89,1.29c-0.9-0.09-1.04-0.52-0.57-1.24

C1020.35,425.03,1021.08,424.83,1021.89,424.89z" />
        <path class="st30" d="M1237.83,84.01c0,0.43,0.11,0.79,0.51,1.01c-0.91,0.98-2.09,1.37-3.62,1.81

C1234.92,84.64,1236.94,84.95,1237.83,84.01z" />
        <path class="st13" d="M530.87,635.65c0.22,0.22,0.45,0.43,0.67,0.65c-0.94,0.57-1.87,1.13-2.81,1.7c-0.24-0.49-0.71-0.53-1.16-0.6

C528.53,636.56,529.7,636.09,530.87,635.65z" />
        <path class="st31" d="M545.6,631.76c-0.19-0.36-0.39-0.72-0.58-1.08c1.24-0.02,2.5-0.31,3.97,0.39

C547.79,631.79,546.72,631.86,545.6,631.76z" />
        <path class="st32" d="M693.89,472.3c-0.23-0.23-0.46-0.47-0.69-0.7c0.96-0.36,1.93-0.72,2.89-1.08c0.58-0.2,0.7,0.06,0.56,0.57

C695.85,471.77,695.06,472.48,693.89,472.3z" />
        <path class="st33" d="M1184.89,262.62c-0.26-0.27-0.52-0.54-0.78-0.81c0.27-0.86,1.04-1.18,1.71-1.62c0.28,0.53,0.8,0.66,1.33,0.75

C1186.4,261.51,1185.64,262.07,1184.89,262.62z" />
        <path class="st7" d="M1260.83,77.06c0.06-0.5-0.11-0.89-0.55-1.15c1.06-0.72,1.81,0.11,2.72,0.42

C1262.49,77.54,1261.57,76.99,1260.83,77.06z" />
        <path class="st34" d="M1019.7,425.52c-0.02,0.51,0.04,0.98,0.57,1.24c-0.73,0.5-1.7,0.79-2.02-0.16

C1017.94,425.71,1018.94,425.55,1019.7,425.52z" />
        <path class="st35" d="M696.64,471.09c-0.19-0.19-0.37-0.38-0.56-0.57c0.67-0.79,1.52-0.39,2.54-0.56

C698.26,471.33,697.41,471.13,696.64,471.09z" />
        <path class="st28" d="M1255.79,76.51c-1.16,1.12-2.59,0.54-3.92,0.63C1253.07,76.29,1254.46,76.59,1255.79,76.51z" />
        <path class="st36" d="M896.78,450.28c0,0.23,0,0.45,0,0.68c-0.44,0.51-1.29,1-1.5,0.35C895.01,450.46,896.02,450.3,896.78,450.28z" />
        <path class="st37" d="M1473.87,62.97c0.66-0.71,1.21-1.58,2.34-1.61C1475.68,62.27,1475.09,63.08,1473.87,62.97z" />
        <path class="st38" d="M1233.98,86.94c-0.2,0.26-0.32,0.56-0.5,0.62 c-0.43,0.12-0.65-0.19-0.57-0.58c0.04-0.2,0.32-0.42,0.52-0.47

C1233.56,86.48,1233.76,86.76,1233.98,86.94z" />
        <!-- <circle :ref="'point'+index" class="point" :cx="item.x" :cy="item.y" r="7" fill="#fff" :id="'point'+index" v-for="(item, index) in arr" />
        <text class="year" :x="item.x" fill="#FFF" :y="item.y" dx="15" dy="8" v-for="(item, index) in arr" :key="index">{{item.year}}</text> -->
        <circle :ref="'point'+index" class="point" :cx="item.location.x" :cy="item.location.y" r="7" fill="#fff" :id="'point'+index" v-for="(item, index) in list" @mouseenter="chooseYear(index)" @mouseleave="out(index)" />
        <text class="year" :x="item.location.x" fill="#FFF" :y="item.location.y" dx="15" dy="8" v-for="(item, index) in list" :key="index">{{item.name}}</text>
    </svg>
    <transition name="fade">
        <div class="wrapper" v-show="current.y" :style="{top:current.y+'px',left:current.x+'px'}">
            <div class="years">{{current.year}}</div>
            <div class="desc">{{current.content}}</div>
        </div>
    </transition>
</div>
</template>

<script>
import {
    lc
} from "../assets/js/api";
export default {
    props: {
        msg: String,
    },
    data() {
        return {
            current: {},
            show: true,
            list: [],
            arr: [{
                    x: 1020.35,
                    y: 425.03,
                },
                {
                    x: 547.79,
                    y: 631.79,
                },
                {
                    x: 1200,
                    y: 140.23,
                },
                {
                    x: 1105.69,
                    y: 255.75,
                },
                {
                    x: 855.69,
                    y: 455.75,
                },
                {
                    x: 695.85,
                    y: 471.77,
                },
                {
                    x: 1220.05,
                    y: 170.02,
                },
            ],
            loaction: {},
        };
    },
    created() {
        this.arr = this.arr.sort((a, b) => {
            return b.y - a.y;
        });
        this.arr.forEach((val, index) => {
            val.year = new Date().getFullYear() + index;
        });
    },

    mounted() {
        lc().then((r) => {
            r.data.data.forEach((val, index) => {
                val.location = this.arr[index];
            });
            this.list = r.data.data;
            this.$nextTick(() => {
                let doc = document.getElementById("point" + (r.data.data.length - 1));
                // let doc = this.$refs['point' + (r.data.data.length - 1)]
                this.current = {
                    x: doc.getBoundingClientRect().x + 100,
                    y: doc.getBoundingClientRect().y - 45,
                    year: r.data.data[r.data.data.length - 1].name,
                    content: r.data.data[r.data.data.length - 1].content,
                };
                this.loaction = {
                    e: doc,
                    idx: r.data.data[r.data.data.length - 1],
                };
            });
        });
        window.addEventListener("scroll", (e) => {
            this.current = {
                x: this.loaction.e.getBoundingClientRect().x + 100,
                y: this.loaction.e.getBoundingClientRect().y - 45,
                year: this.loaction.idx.name,
                content: this.loaction.idx.content,
            };
        });
    },
    methods: {
        chooseYear(e) {
            this.current = {
                x: event.clientX + 100,
                y: event.clientY - 45,
                year: this.list[e].name,
                content: this.list[e].content,
            };
            this.loaction = {
                e: document.getElementById("point" + e),
                idx: this.list[e],
            };
        },
        out() {
            this.current = {};
            this.loaction = {}
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.st0 {
    fill: #247bd6;
}

.st2 {
    fill: #4991dd;
}

.point {
    cursor: pointer;
}

.year {
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    opacity: 0.6;
}

.wrapper {
    display: flex;
    min-height: 80px;
    position: fixed;
}

.wrapper div {
    padding: 20px 20px;
}

.wrapper .years {
    width: 125px;
    font-size: 36px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: rgba(255, 254, 254, 1);
    background: url("../assets/img/year.png") no-repeat;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin-right: 5px;
}

.wrapper .desc {
    width: 18vw;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: rgba(0, 0, 0, 1);
    background: white;
    text-align: left;
}
</style>
